import { AxiosRequestConfig, AxiosResponse, AxiosInstance } from "axios"

import { ResponseData } from "../common"

export interface FavouritesListParams {
  favouriteListName: string
}

export interface AddFavouriteListRequest extends Partial<AxiosRequestConfig> {
  params: FavouritesListParams
}

export interface AddFavListResponse {
  favoriteId: number
  favouriteName: string
  isActive: boolean
  isRemoved: null
  oldFavoriteListName: null
  userId: number
  userIds: string
}

export interface AddFavouritesListResponseData extends ResponseData {
  data: AddFavListResponse
}
export interface AddFavouritesListResponse extends AxiosResponse {
  data: AddFavouritesListResponseData
}

export function createFavoriteListApi(
  { params }: AddFavouriteListRequest,
  axiosInstance: AxiosInstance,
): Promise<AddFavouritesListResponse> {
  const url = `/user/favouritelist/addfavouritelist`

  return axiosInstance({
    data: params,
    method: "post",
    url,
  }) as Promise<AddFavouritesListResponse>
}
